import { render, staticRenderFns } from "./DetailSoalPsikologi.vue?vue&type=template&id=39cd6d85"
import script from "./DetailSoalPsikologi.vue?vue&type=script&lang=js"
export * from "./DetailSoalPsikologi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports